import Aboutus from './Components/Aboutus';
import Home from './Components/Home';
import Navbar from './Components/Navbar';
import {BrowserRouter as Router,Route, Routes} from 'react-router-dom';
import Services from './Components/Services';
import Contactus from './Components/Contactus';
import Index from './Components/Index';

function App() {

  return (
    <Router>
      <div>
      <Navbar />
      <Routes>
        <Route path="/" element={<Index />} />
        <Route path="/Home" element={<Home />} />
        <Route path="/aboutus" element={<Aboutus />} />
        <Route path="/services" element={<Services />} />
        <Route path="/contactus" element={<Contactus />} />
      </Routes>
      </div>
    </Router>
  );
}

export default App;
